import { useEffect, useState } from 'react';
import ModalDatePicker from '../../modal/views/ModalDatePicker';

const FavoriteAddModal = ({ favorite }) => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            const trigger = e.target.closest(`[data-open-favorite-date-picker="${favorite.id}"]`);

            if (trigger) setIsOpen(true);
        };

        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, [favorite.id]);

    useEffect(() => {
        document.body.classList.toggle('modal-open', isOpen);
        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="modal" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <ModalDatePicker
                        currentDay={new Date().toISOString().slice(0, 10)}
                        favoriteId={favorite.id}
                        favoriteName={favorite.name}
                        entryType={favorite.meal_type}
                        action="add"
                        onRequestClose={() => setIsOpen(false)}
                    />
                </div>
            </div>

            <div className="modal-backdrop fade in" onClick={() => setIsOpen(false)} />
        </div>
    );
};

export default FavoriteAddModal;
